import React from 'react';
import { PageMeta } from '../../components/PageMeta';
import { ModaPrivate } from '../../components/ModaPrivate';

export const ModaPrivatePage: React.FC = () => (
  <>
    <PageMeta
      title="Moda Private"
      description="Experience best-in-class personal shopping services with Moda Private."
    />
    <ModaPrivate />
  </>
);
